<script>

    import { toast } from 'bulma-toast'

    import TilService from '../$services/til.service'
    import DateMethod from '../$methods/date.method'

    import Button from '../$components/button.svelte'
    import DateField from '../$components/date.svelte'
    import Form from '../$components/form.svelte'
    import SelectUsers from '../$components/select.users.svelte'

    export let dateStart = null
    export let dateEnd = null

    let data = {}
    let loading = false
    let element = null

    $: if (dateStart && dateEnd) {
        data.dateStart = new Date(dateStart)
        data.dateEnd = new Date(dateEnd)
    }

    async function downloadTrackings() {

        loading = true
        const blob = await TilService.downloadTrackingsTil(data)
        loading = false

        if (!blob)
            return toast({ message: 'Error al descargar el archivo', type: 'is-danger' })

        const fileName = `trackings_til_${ DateMethod.dateShort(data.dateStart) }_${ DateMethod.dateShort(data.dateEnd) }`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Form on:submit={downloadTrackings} {loading}>
    <div class="columns is-multiline">
        <div class="column is-full">
            <SelectUsers bind:userId={data.driverId} role="driver" label="Conductor" />
        </div>
        <div class="column is-half-tablet">
            <DateField label="Fecha de inicio" bind:value={data.dateStart} />
        </div>
        <div class="column is-half-tablet">
            <DateField label="Fecha final" bind:value={data.dateEnd} />
        </div>
    </div>
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button type="submit" text="Descargar" icon="download" />
    </div>
</Form>
